module.exports = __webpack_public_path__ + "static/media/creator-background-lrg.ddbeb5c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/creator-background-lrg.jpg
// module id = 328
// module chunks = 0